import { useContext, useEffect, useRef, useState } from 'react'
import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { TextBoxMaxLine1FontSmBold } from 'atoms/TextBox/Templates'
import { COLOR } from 'vars/index'
import { HintsScrollContext } from '../HintsContainer.h'
import { SearchHintSC } from './SearchHint.styled'

export interface ISearchHintProps {
  title: string
  onClick: () => void
}

export const SearchHint = ({ title, onClick }: ISearchHintProps) => {
  const itemRef = useRef<HTMLDivElement>(null)
  const [isFullyVisible, setIsFullyVisible] = useState(true)
  const scrollContainerRef = useContext(HintsScrollContext)

  useEffect(() => {
    const container = scrollContainerRef?.current
    const item = itemRef.current
    if (!container || !item) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Use 0.99 instead of 1 - iOS Safari has sub-pixel rendering bugs where
        // intersectionRatio never reaches exactly 1 for fully visible elements
        setIsFullyVisible(entry.intersectionRatio >= 0.99)
      },
      {
        root: container,
        threshold: 0.99,
      }
    )

    observer.observe(item)
    return () => observer.disconnect()
  }, [scrollContainerRef])

  const handleClick = () => {
    if (!isFullyVisible && itemRef.current) {
      itemRef.current.scrollIntoView({
        block: 'nearest',
        inline: 'center',
        behavior: 'smooth',
      })
    }
    onClick()
  }

  return (
    <SearchHintSC
      ref={itemRef}
      isFullyVisible={isFullyVisible}
      onClick={handleClick}
    >
      <Icon
        name={IconNames.searchHint}
        size={IconSizes.small}
        color={COLOR.ACCENT_TERTIARY}
      />
      <TextBoxMaxLine1FontSmBold title={title} />
    </SearchHintSC>
  )
}
